<template>
  <div>
    <div class="common-form">高级设置</div>

    <!-- 红包设置部分 -->
    <template v-if="Number(form.coupon_type)">
      <!-- 签到红包 (1) -->
      <div v-if="Number(form.coupon_type) === 50 || Number(form.coupon_type) === 111">
        <el-form-item label="属性">
          <el-select
            v-model="form.hongbao_att"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="等额" :value="1"></el-option>
            <el-option label="随机" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="赠送金额" v-if="form.hongbao_att == 1">
          <el-input
            v-model="form.price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最低值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.min_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最高值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.max_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="关联任务" prop="gtask_id">
          <el-select
            v-model="form.gtask_id"
            filterable
            placeholder="请选择任务"
            style="width: 100%"
            :loading="loadingGtasks"
            @change="handleTaskChange"
          >
            <el-option
              v-for="gtask in gtaskList"
              :key="gtask.gtask_id"
              :label="gtask.name"
              :value="gtask.gtask_id"
            />
          </el-select>
        </el-form-item>
      </div>

      <!-- 幸运红包 (2) -->
      <div v-if="Number(form.coupon_type) === 60">
        <el-form-item label="属性">
          <el-select
            v-model="form.hongbao_att"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="等额" :value="1"></el-option>
            <el-option label="随机" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="赠送金额" v-if="form.hongbao_att == 1">
          <el-input
            v-model="form.price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最低值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.min_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最高值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.max_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="每日随机赠送数量">
          <el-input
            v-model="form.day_random_given"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="每日赠送上限">
          <el-input
            v-model="form.day_max_given"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="会员每天可抢">
          <el-input
            v-model="form.day_vip_grab"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="从第几个红包开始">
          <el-input
            v-model="form.start_grab"
            placeholder="1"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="提示文字">
          <el-input
            v-model="form.tip_grab"
            placeholder="例如：约好友一起抢红包"
          ></el-input>
        </el-form-item>
        <el-form-item label="分享好友数量">
          <el-input
            v-model="form.share_friend"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="分享赠送次数">
          <el-input
            v-model="form.share_re_given"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>
      </div>

      <!-- 惊喜红包 (3) -->
      <div v-if="Number(form.coupon_type) === 70">
        <el-form-item label="属性">
          <el-select
            v-model="form.hongbao_att"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="等额" :value="1"></el-option>
            <el-option label="随机" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="赠送金额" v-if="form.hongbao_att == 1">
          <el-input
            v-model="form.price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最低值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.min_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最高值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.max_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="红包金额">
          <el-input
            v-model="form.hongbao_amount"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>
      </div>

      <!-- 产品红包 (4) -->
      <div v-if="Number(form.coupon_type) === 80">
        <el-form-item label="属性">
          <el-select
            v-model="form.hongbao_att"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="等额" :value="1"></el-option>
            <el-option label="随机" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="赠送金额" v-if="form.hongbao_att == 1">
          <el-input
            v-model="form.price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最低值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.min_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最高值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.max_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="关联产品" prop="product_id">
          <el-select
            v-model="form.product_id"
            filterable
            placeholder="请选择产品"
            style="width: 100%"
            :loading="loadingPorducts"
          >
            <el-option
              v-for="product in productList"
              :key="product.product_id"
              :label="product.product_name"
              :value="product.product_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="直推奖励">
          <el-radio-group v-model="form.is_extral_reward">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="奖励金额" v-if="form.is_extral_reward === 1">
          <el-input
            v-model="form.extral_reward"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>
      </div>

      <!-- 生日红包 (5) -->
      <div v-if="Number(form.coupon_type) === 90">
        <el-form-item label="属性">
          <el-select
            v-model="form.hongbao_att"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="等额" :value="1"></el-option>
            <el-option label="随机" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="赠送金额" v-if="form.hongbao_att == 1">
          <el-input
            v-model="form.price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最低值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.min_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最高值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.max_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>
      </div>

      <!-- 节日红包 (6) -->
      <div v-if="Number(form.coupon_type) === 100">
        <el-form-item label="属性">
          <el-select
            v-model="form.hongbao_att"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="等额" :value="1"></el-option>
            <el-option label="随机" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="赠送金额" v-if="form.hongbao_att == 1">
          <el-input
            v-model="form.price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最低值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.min_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>

        <el-form-item label="最高值" v-if="form.hongbao_att == 2">
          <el-input
            v-model="form.max_price"
            placeholder="0"
            type="number"
          ></el-input>
        </el-form-item>
      </div>
    </template>

    <!-- 原有优惠券设置部分 -->
    <div v-if="Number(form.coupon_type) === 10">
      <el-form-item label="减免金额">
        <el-input
          v-model="form.reduce_price"
          placeholder="请输入减免金额"
          type="number"
        ></el-input>
      </el-form-item>
    </div>
    <div v-else>
      <el-form-item label="折扣率 " v-if="Number(form.coupon_type) === 20">
        <el-input
          v-model="form.discount"
          placeholder="请输入折扣率"
          type="number"
        ></el-input>
        <div class="tips">折扣率范围0-10，9.5代表9.5折，0代表不折扣</div>
      </el-form-item>
    </div>

    <!-- 通用字段 -->
    <el-form-item
      label="最低消费金额"
      v-if="Number(form.coupon_type) === 10 || Number(form.coupon_type) === 20"
    >
      <el-input
        v-model="form.min_price"
        placeholder="请输入最低消费金额"
        type="number"
      ></el-input>
    </el-form-item>

    <!-- <el-form-item
      label="发放总数量 "
      prop="total_num"
      :rules="[{ required: true, message: ' ' }]"
    >
      <el-input
        v-model="form.total_num"
        placeholder="请输入发放总数量"
        type="number"
      ></el-input>
      <div class="tips">限制领取的数量，-1为不限制</div>
    </el-form-item> -->
    <el-form-item label="发放总数" prop="total_num">
  <el-input 
    v-model="form.total_num" 
    placeholder="请输入发放总数"
    type="number"
    :disabled="form.user_range === 3" 
  ></el-input>
  <div class="tips">
    <span v-if="form.user_range === 1">全部用户模式下：-1表示不限制，大于0表示限制数量</span>
    <span v-else-if="form.user_range === 2">随机用户模式下：必须大于0</span>
    <span v-else>指定用户模式下：自动等于选择的用户数</span>
  </div>
</el-form-item>
    <el-form-item label="排序">
      <el-input
        type="number"
        v-model="form.sort"
        placeholder="请输入排序"
      ></el-input>
    </el-form-item>
  </div>
</template>

<script>
import { method } from "lodash";
import ProductApi from "@/api/product.js";
import GtaskApi from "@/api/gtask.js";
export default {
  props: ["form"],
  data() {
    return {
      gtaskList: [],
      loadingGtasks: false,
      productList: [],
      loadingPorducts: false
    };
  },
  created() {
    this.addProductList();
    this.addGtaskList();
  },
  methods: {
    addProductList() {
      let self = this;
      ProductApi.productListx({}, true).then(data => {
        self.loading = false;
        self.productList = data.data;
        console.log("productList", self.productList);
      });
    },
    addGtaskList() {
      let self = this;
      GtaskApi.gtaskListx({}, true).then(data => {
        self.loading = false;
        self.gtaskList = data.data;
        console.log("gtaskList", self.gtaskList);
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/part/Coupon.vue